import { render, staticRenderFns } from "./ProductEditorLogistics.vue?vue&type=template&id=5105b229&"
import script from "./ProductEditorLogistics.vue?vue&type=script&lang=js&"
export * from "./ProductEditorLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports